import { useMemo } from "react"
import { useTranslation } from "react-i18next"

export const useProductionSiteFormErrorTranslations =
  (): Readonly<Record<string, string>> => {
    const { t } = useTranslation("supplier")

    return useMemo(
      () => ({
        "productionSiteModal.errors.cityRequired": t(
          "productionSiteModal.errors.cityRequired"
        ),
        "productionSiteModal.errors.coordinatesMaxDecimals": t(
          "productionSiteModal.errors.coordinatesMaxDecimals"
        ),
        "productionSiteModal.errors.countryMustBeValid": t(
          "productionSiteModal.errors.countryMustBeValid"
        ),
        "productionSiteModal.errors.internalCodeTooLong": t(
          "productionSiteModal.errors.internalCodeTooLong"
        ),
        "productionSiteModal.errors.nameRequired": t(
          "productionSiteModal.errors.nameRequired"
        ),
        "productionSiteModal.errors.parentCompanyRequired": t(
          "productionSiteModal.errors.parentCompanyRequired"
        ),
        "productionSiteModal.errors.postalCodeTooShort": t(
          "productionSiteModal.errors.postalCodeTooShort"
        ),
        "productionSiteModal.errors.streetRequired": t(
          "productionSiteModal.errors.streetRequired"
        ),
        "productionSiteModal.errors.streetTooShort": t(
          "productionSiteModal.errors.streetTooShort"
        ),
      }),
      [t]
    )
  }
